import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API from "./config/API";

function RoomMaxSetUp() {
  const [formData, setFormData] = useState([]);
  const [popup, setPopup] = useState("");

  const navigate = useNavigate();

  // ✅ GET EMAIL FROM LOCAL STORAGE
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const emailId = loggedUser?.emailId || "";

  useEffect(() => {
    if (emailId) {
      fetchFloors();
    } else {
      showPopup("User email not found. Please login again.");
    }
  }, [emailId]);

  // ✅ FETCH FLOORS
  const fetchFloors = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const res = await axios.get(`${API.V1}/maxLimit/getFloorRoomDetails`, {
        params: {
          emailId: emailId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.jwtToken}`,
        },
      });

      if (res.data.statusCode === 200) {
        const floorList = res.data.data.floorList || [];
        const roomList = res.data.data.roomList || [];

        // Count rooms per floor
        const roomCountMap = {};

        roomList.forEach((room) => {
          if (!roomCountMap[room.floorName]) {
            roomCountMap[room.floorName] = 0;
          }
          roomCountMap[room.floorName]++;
        });

        // Prepare UI data
        const initialData = floorList.map((floor) => ({
          floorName: floor.floorName,
          adminEmailId: emailId,
          maxCountRooms: roomCountMap[floor.floorName] || "",
        }));

        setFormData(initialData);
      } else if (res.data.statusCode === 400) {
        showPopup(res.data.message || "No floors found");
      } else {
        showPopup(res.data.message || "Failed to load floors");
      }
    } catch (err) {
      if (err.response?.status === 401) {
        alert("Session expired. Please login again.");
        localStorage.clear();
        navigate("/");
      } else {
        console.error(err);
        showPopup("500 : Server down, Please try after sometime!");
      }
    }
  };

  // ✅ POPUP MESSAGE
  const showPopup = (msg) => {
    setPopup(msg);

    setTimeout(() => {
      setPopup("");
    }, 2500);
  };

  // ✅ HANDLE CHANGE
  const handleChange = (index, value) => {
    const updated = [...formData];

    updated[index].maxCountRooms = value;

    setFormData(updated);
  };

  // ✅ SUBMIT
  const handleSubmit = async () => {
    for (let item of formData) {
      if (!item.maxCountRooms) {
        showPopup("Please fill all room counts");
        return;
      }
    }

    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const payload = formData.map((item) => ({
        floorName: item.floorName,
        adminEmailId: item.adminEmailId,
        maxCountRooms: Number(item.maxCountRooms),
      }));

      const res = await axios.post(
        `${API.V1}/maxLimit/createMaxRoomsCount`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (res.data.statusCode === 200) {
        showPopup(res.data.message || "Saved successfully!");

        setTimeout(() => {
          navigate("/configurationSetUpCount");
        }, 1200);
      } else if (res.data.statusCode === 400) {
        showPopup(res.data.message || "Validation failed");
      } else {
        showPopup(res.data.message || "Failed to save");
      }
    } catch (err) {
      if (err.response?.status === 401) {
        alert("Session expired. Please login again.");
        localStorage.clear();
        navigate("/");
      } else {
        console.error(err);
        showPopup("500 : Server down, Please try after sometime!");
      }
    }
  };

  return (
    <div style={styles.container}>
      {/* ✅ POPUP */}
      {popup && <div style={styles.popup}>{popup}</div>}

      <div style={styles.card}>
        <h2 style={styles.title}>Room Max Setup</h2>

        <div style={styles.emailBox}>
          Logged In Email : <b>{emailId}</b>
        </div>

        {/* ✅ FLOOR LIST */}
        {formData.length > 0 ? (
          formData.map((floor, index) => (
            <div key={index} style={styles.row}>
              {/* FLOOR NAME */}
              <div style={styles.field}>
                <label style={styles.label}>Floor Name</label>

                <input
                  type="text"
                  value={floor.floorName}
                  readOnly
                  style={styles.readOnlyInput}
                />
              </div>

              {/* MAX ROOM COUNT */}
              <div style={styles.field}>
                <label style={styles.label}>Max Rooms Count</label>

                <input
                  type="number"
                  value={floor.maxCountRooms}
                  onChange={(e) => handleChange(index, e.target.value)}
                  placeholder="Enter room count"
                  style={styles.input}
                />
              </div>
            </div>
          ))
        ) : (
          <div style={styles.noData}>No Floor Data Available</div>
        )}

        {/* SUBMIT BUTTON */}
        {formData.length > 0 && (
          <button style={styles.button} onClick={handleSubmit}>
            Submit All
          </button>
        )}
      </div>
    </div>
  );
}

export default RoomMaxSetUp;

/* ==================== STYLES ==================== */

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(to right, #dbeafe, #f8fafc)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },

  card: {
    width: "700px",
    background: "#ffffff",
    padding: "30px",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
  },

  title: {
    textAlign: "center",
    marginBottom: "20px",
    color: "#0f172a",
    fontSize: "28px",
    fontWeight: "bold",
  },

  emailBox: {
    background: "#e0f2fe",
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "20px",
    color: "#0369a1",
    fontWeight: "600",
    textAlign: "center",
  },

  row: {
    display: "flex",
    gap: "20px",
    marginBottom: "18px",
  },

  field: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },

  label: {
    marginBottom: "6px",
    fontWeight: "bold",
    color: "#334155",
  },

  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    outline: "none",
    fontSize: "15px",
    background: "#fff",
  },

  readOnlyInput: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    outline: "none",
    fontSize: "15px",
    background: "#f1f5f9",
    color: "#475569",
    fontWeight: "600",
  },

  button: {
    width: "100%",
    padding: "14px",
    background: "linear-gradient(to right, #2563eb, #1d4ed8)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontWeight: "bold",
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "15px",
    transition: "0.3s",
  },

  popup: {
    position: "fixed",
    top: "20px",
    right: "20px",
    background: "#111827",
    color: "#fff",
    padding: "12px 18px",
    borderRadius: "8px",
    zIndex: 999,
    fontWeight: "bold",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },

  noData: {
    textAlign: "center",
    padding: "20px",
    color: "#dc2626",
    fontWeight: "bold",
  },
};
